import { DefaultSpinner } from '~/common/components/defaultUIComponents/DefaultSpinner';
import { CompanySettingsProvider } from '~/common/services/CompanySettingsService';
import { useAuthenticationService } from '~/common/services/AuthenticationService';
import { Wrapper } from '~/common/components/defaultUIComponents/Wrapper';
import { DepartmentProvider } from '~/common/services/DepartmentService';
import { SpecialJobProvider } from '~/common/services/SpecialJobService';
import { useSettingsService } from '~/common/services/SettingsService';
import { ApiContextProvider } from '~/common/api/common/apiCommons';
import { DayplanProvider } from '~/common/services/DayplanService';
import { PictureProvider } from '~/common/services/PictureService';
import { ProjectProvider } from '~/common/services/ProjectService';
import { RoutineProvider } from '~/common/services/RoutineService';
import { RoleProvider } from '~/common/services/RoleService';
import React, { ReactNode, useEffect } from 'react';
import { Flex } from '@chakra-ui/react';

const App: React.FC<{ children: ReactNode }> = (props) => {
  const { children } = props;
  const { loadFromStorage, loading } = useAuthenticationService();
  const { loadSettingsFromStorage, loading: settingsLoading } =
    useSettingsService();

  useEffect(() => {
    loadFromStorage();
  }, []);

  useEffect(() => {
    if (!loading) {
      loadSettingsFromStorage();
    }
  }, [loading]);

  if (loading || settingsLoading) {
    return (
      <Wrapper variant="small">
        <Flex mt="15vh">
          <DefaultSpinner />
        </Flex>
      </Wrapper>
    );
  }
  return (
    <ApiContextProvider>
      <CompanySettingsProvider>
        <SpecialJobProvider>
          <RoutineProvider>
            <ProjectProvider>
              <PictureProvider>
                <DayplanProvider>
                  <DepartmentProvider>
                    <RoleProvider>{children}</RoleProvider>
                  </DepartmentProvider>
                </DayplanProvider>
              </PictureProvider>
            </ProjectProvider>
          </RoutineProvider>
        </SpecialJobProvider>
      </CompanySettingsProvider>
    </ApiContextProvider>
  );
};

export default App;
